module.exports = __webpack_public_path__ + "img/img21.d6c896a1.png";